module.exports = __webpack_public_path__ + "img/Aptamil_FO_2_1200g_062022_front_left-removebg-preview_0.df1db31c.png";